import React, { Component } from 'react';

import PaginationComponent from './PaginationComponent';
import { sortClass, nextSortDir, sortAriaSort } from '../utils/table';
import { buildPaginationQuery, getPaginatedData, scheduleDebouncedCallback, clearDebouncedCallback } from '../utils/pagination';
import { hasActiveSearch, getSearchEmptyMessage } from '../utils/tableState';
import { navigateTo } from '../utils/navigation';
import { darDeBaja, etiquetaTipo, fechaCorta } from '../utils/discountCodesApi';

var config = process.env;

class TableDiscountCodesComponent extends Component {

    constructor() {
        super();
        this.state = {
            quantityShowRows: 25,
            currentPage: 1,
            totalItems: 0,
            search: '',
            searchInput: '',
            sortBy: 'code',
            sortDir: 'asc',
            data: [],
            loaded: false,
            // Baja en curso: el código, el nombre de quien la hace y el estado del envío.
            baja: null, bajaNombre: '', bajaEnviando: false, bajaError: null, aviso: null,
        };
    }

    componentDidMount() {
        this.fetchData();
    }

    componentWillUnmount() {
        clearDebouncedCallback(this, 'searchDebounceTimeout');
    }

    fetchData = ({
        page = this.state.currentPage,
        limit = this.state.quantityShowRows,
        search = this.state.search,
        sortBy = this.state.sortBy,
        sortDir = this.state.sortDir,
        showLoader = true,
    } = {}) => {
        if (showLoader) {
            this.setState({ loaded: false });
        }
        var request = {
            method: 'GET',
            headers: {
                'access-token': localStorage.getItem('token'),
                'Content-Type': 'application/json',
            }
        };

        const query = buildPaginationQuery({ page, limit, search, sortBy, sortDir });
        fetch(`${config.REACT_APP_BASE_URL}${config.REACT_APP_VERSION}discountCode?${query}`, request)
        .then(results => results.json())
        .then(data => {
            if (data.error > 0) {
                alert(data.message);
                if (data.error == 1002) {
                    window.location.href = localStorage.getItem('homePageURL');
                }
            } else {
                const paginatedData = getPaginatedData(data);
                this.setState({
                    data: paginatedData.items || [],
                    quantityShowRows: paginatedData.limit || Number(limit),
                    currentPage: paginatedData.page || Number(page),
                    totalItems: paginatedData.total || 0,
                    search,
                    sortBy,
                    sortDir,
                    loaded: true,
                });
            }
        });
    }

    renderEmptyState = () => {
        return (
            <div
                style={{
                    background: '#ffffff',
                    borderRadius: '0.625rem',
                    boxShadow: '0 .125rem .625rem rgba(90,97,105,.12)',
                    border: '1px solid #e1e5eb',
                    minHeight: '320px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '2rem',
                }}
            >
                <div style={{ textAlign: 'center', maxWidth: '420px' }}>
                    <div
                        style={{
                            width: '72px',
                            height: '72px',
                            margin: '0 auto 1rem',
                            borderRadius: '50%',
                            background: '#f5f6f8',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                    >
                        <i className="material-icons" style={{ fontSize: '34px', color: '#818ea3' }}>sell</i>
                    </div>
                    <h4 style={{ marginBottom: '0.75rem', color: '#3d5170', fontWeight: 500 }}>
                        Todavia no hay codigos de descuento para mostrar
                    </h4>
                    <p style={{ margin: 0, color: '#818ea3', lineHeight: 1.6 }}>
                        Cuando crees codigos de descuento, aca vas a ver sus fechas, tipo,
                        limites de uso y estado de utilizacion.
                    </p>
                </div>
            </div>
        );
    }

    renderLoader = () => {
        return (
            <div
                style={{
                    background: '#ffffff',
                    borderRadius: '0.625rem',
                    boxShadow: '0 .125rem .625rem rgba(90,97,105,.12)',
                    border: '1px solid #e1e5eb',
                    minHeight: '320px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '2rem',
                }}
            >
                <div className="containerLoader" style={{ display: 'block', position: 'static', width: '100%' }}>
                    <div className="loader"></div>
                </div>
            </div>
        );
    }

    drawRow = (item, index) => {
        return (
            <tr role="row" className="odd" key={item.code} style={{ background: index % 2 == 0 ? '#ffffff;' : '#fcfcfc' }}>
                <td>{item.code}</td>
                <td>{item.discount}</td>
                <td>{fechaCorta(item.from)}</td>
                <td>{fechaCorta(item.to)}</td>
                <td>{item.any == 1 ? 'Sí' : 'No'}</td>
                <td>{etiquetaTipo(item.type)}</td>
                <td>{item.max_amount}</td>
                <td>{item.single_use == 1 ? 'Sí' : 'No'}</td>
                <td>{item.used == 1 ? 'Sí' : 'No'}</td>
                <td style={{ whiteSpace: 'nowrap' }}>
                    <button type="button" className="btn btn-sm btn-outline-primary mr-1"
                        onClick={() => navigateTo(`/editDiscountCode?code=${encodeURIComponent(item.code)}`)}>
                        Editar
                    </button>
                    <button type="button" className="btn btn-sm btn-outline-danger"
                        onClick={() => this.setState({ baja: item.code, bajaNombre: '', bajaError: null, aviso: null })}>
                        Dar de baja
                    </button>
                </td>
            </tr>
        );
    }

    loadData = () => {
        if (!this.state.loaded) {
            return <tbody></tbody>;
        }

        const items = this.state.data.map((item, index) => this.drawRow(item, index));
        if (items.length === 0) {
            items.push(
                <tr key="empty">
                    <td colSpan="10" style={{ textAlign: 'center', padding: '10px', border: '1px solid rgb(225, 229, 235)' }}>
                        {getSearchEmptyMessage(this.state.searchInput || this.state.search)}
                    </td>
                </tr>
            );
        }
        return <tbody>{items}</tbody>;
    }

    onChangeShowRows = () => {
        const itemSelected = Number(document.getElementById('select_rows').value);
        this.fetchData({ page: 1, limit: itemSelected });
    }

    onChangeInput = (search) => {
        this.setState({ searchInput: search });
        scheduleDebouncedCallback(this, 'searchDebounceTimeout', () => {
            this.fetchData({ page: 1, search, showLoader: false });
        });
    }

    orderData = (column) => {
        this.fetchData({
            page: 1,
            sortBy: column,
            sortDir: nextSortDir(column, this.state.sortBy, this.state.sortDir),
        });
    }

    // Props de una cabecera ordenable: la clase y el aria-sort se derivan del state, así que
    // sobreviven al remonte que provoca el loader.
    sortableHeader = (column) => ({
        onClick: () => this.orderData(column),
        className: sortClass(column, this.state.sortBy, this.state.sortDir),
        'aria-sort': sortAriaSort(column, this.state.sortBy, this.state.sortDir),
        tabIndex: '0',
    })

    confirmarBaja = async () => {
        const { baja, bajaNombre, bajaEnviando } = this.state;
        if (bajaEnviando) return;
        if (bajaNombre.trim().length < 2) {
            this.setState({ bajaError: 'Escribí tu nombre: queda registrado quién dio de baja el código.' });
            return;
        }
        this.setState({ bajaEnviando: true, bajaError: null });
        try {
            await darDeBaja(baja, bajaNombre.trim());
            this.setState({ baja: null, bajaEnviando: false, aviso: `Se dio de baja el código ${baja}.` });
            this.fetchData({ showLoader: false });
        } catch (e) {
            this.setState({ bajaEnviando: false, bajaError: e.message || 'No se pudo dar de baja.' });
        }
    }

    // Confirmación de la baja: en la página y controlada por React (sin modal de Bootstrap), con el
    // nombre obligatorio porque el login del local es compartido.
    renderBaja = () => {
        const { baja, bajaNombre, bajaEnviando, bajaError } = this.state;
        if (!baja) return null;
        return (
            <div className="alert alert-warning" role="dialog" aria-label={`Dar de baja ${baja}`}>
                <p className="mb-2">
                    ¿Dar de baja el código <strong>{baja}</strong>? Deja de aplicar en la tienda, el mostrador y la
                    cafetería. Las ventas que ya lo usaron no cambian, y el mismo texto no se puede volver a crear.
                </p>
                <div className="form-inline">
                    <input type="text" className="form-control mr-2 mb-2" placeholder="Tu nombre" maxLength={60}
                        value={bajaNombre} autoFocus
                        onChange={(e) => this.setState({ bajaNombre: e.target.value, bajaError: null })} />
                    <button type="button" className="btn btn-danger mr-2 mb-2" disabled={bajaEnviando} onClick={this.confirmarBaja}>
                        {bajaEnviando ? 'Dando de baja…' : 'Dar de baja'}
                    </button>
                    <button type="button" className="btn btn-outline-secondary mb-2" disabled={bajaEnviando}
                        onClick={() => this.setState({ baja: null })}>
                        Cancelar
                    </button>
                </div>
                {bajaError && <div className="bg-white text-danger rounded p-2 mt-1">{bajaError}</div>}
            </div>
        );
    }

    render() {
        if (!this.state.loaded) {
            return this.renderLoader();
        }

        if (this.state.totalItems === 0 && !hasActiveSearch(this.state.searchInput, this.state.search)) {
            return this.renderEmptyState();
        }

        return (
            <div id="DataTables_Table_0_wrapper" className="dataTables_wrapper no-footer">
                {this.state.aviso && <div className="alert alert-success">{this.state.aviso}</div>}
                {this.renderBaja()}
                <div className="dataTables_length" id="DataTables_Table_0_length">
                    <label>Show
                    <select id="select_rows" name="DataTables_Table_0_length" aria-controls="DataTables_Table_0" value={this.state.quantityShowRows} onChange={() => this.onChangeShowRows()}>
                        <option value="10">10</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                    </select>
                    entries</label>
                </div>
                <div id="DataTables_Table_0_filter" className="dataTables_filter">
                    <label>Search:
                    <input id="input_search" type="search" className="" placeholder="" aria-controls="DataTables_Table_0" value={this.state.searchInput} onChange={(e) => this.onChangeInput(e.target.value)}/>
                    </label>
                </div>

                <table className="transaction-history d-none dataTable no-footer dtr-inline" id="DataTables_Table_0" role="grid" aria-describedby="DataTables_Table_0_info">
                    <thead>
                        <tr role="row">
                            <th {...this.sortableHeader('code')} aria-controls="DataTables_Table_0" rowSpan="1" colSpan="1" style={{ width: '15%' }}>Código</th>
                            <th {...this.sortableHeader('discount')} aria-controls="DataTables_Table_0" rowSpan="1" colSpan="1" style={{ width: '15%' }}>Descuento</th>
                            <th {...this.sortableHeader('from')} aria-controls="DataTables_Table_0" rowSpan="1" colSpan="1" style={{ width: '15%' }}>Desde</th>
                            <th {...this.sortableHeader('to')} aria-controls="DataTables_Table_0" rowSpan="1" colSpan="1" style={{ width: '15%' }}>Hasta</th>
                            <th {...this.sortableHeader('any')} aria-controls="DataTables_Table_0" rowSpan="1" colSpan="1" style={{ width: '10%' }}>Aplica a todos</th>
                            <th {...this.sortableHeader('type')} aria-controls="DataTables_Table_0" rowSpan="1" colSpan="1" style={{ width: '10%' }}>Tipo</th>
                            <th {...this.sortableHeader('max_amount')} aria-controls="DataTables_Table_0" rowSpan="1" colSpan="1" style={{ width: '10%' }}>Descuento máximo</th>
                            <th {...this.sortableHeader('single_use')} aria-controls="DataTables_Table_0" rowSpan="1" colSpan="1" style={{ width: '10%' }}>Unico uso</th>
                            <th {...this.sortableHeader('used')} aria-controls="DataTables_Table_0" rowSpan="1" colSpan="1" style={{ width: '10%' }}>Usado</th>
                            <th rowSpan="1" colSpan="1">Acciones</th>
                        </tr>
                    </thead>
                    {this.loadData()}
                </table>

                <PaginationComponent
                    totalItems={this.state.totalItems}
                    quantityRows={this.state.quantityShowRows}
                    currentPage={this.state.currentPage}
                    onPageChange={(page) => this.fetchData({ page })}
                />
            </div>
        );
    }
}

export default TableDiscountCodesComponent;
